/*
 * Questions shown in the "Common questions" section.
 */
const faqs = [
    {
        q: 'Do I need to know which service I need?',
        a: 'No. Choose “I’m not sure” on the request form. The intake team can discuss your needs and explain available services.',
    },
    {
        q: 'What is the difference between therapy and PRP?',
        a: 'Therapy helps you explore emotions, thoughts, and coping strategies with a clinician. PRP focuses on building everyday skills and independence alongside clinical treatment. PRP has its own eligibility and referral requirements.',
    },
    {
        q: 'Can I request care for my child?',
        a: 'A parent or guardian can contact the office to discuss the child’s needs. Confirm the program’s age range, provider availability, and required consent documents with intake.',
    },
    {
        q: 'Which insurance plans do you accept?',
        a: 'We accept Medicaid, Medicare, UnitedHealthcare, Cigna, Aetna, and CareFirst. Coverage varies by plan and service. Contact intake to verify your benefits.',
    },
    {
        q: 'When can I visit without an appointment?',
        a: 'Walk-in hours are Tuesdays and Wednesdays, 10 am–3 pm. Regular office hours are Monday through Friday, 9 am–5 pm.',
    },
    {
        q: 'Are virtual appointments available?',
        a: 'Ask the intake team about current appointment formats and which services may be available remotely.',
    },
    {
        q: 'Does submitting this form book an appointment?',
        a: 'No. It requests contact from the intake team. Your appointment is confirmed separately.',
    },
    {
        q: 'How can a professional refer a client?',
        a: 'Select “Refer a client” below to explore the referral request. Patient records should be shared only through the clinic’s approved secure referral channel, once confirmed by the office.',
    },
];

export default faqs;
